import {
  Autocomplete,
  AutocompleteRenderInputParams,
  CircularProgress,
  TextField,
} from '@mui/material';
import {useEffect, useState} from 'react';
// import {roleServiceFind} from 'src/apis';
import {roleServiceFind} from 'src/apis/autoGenerate/services';
import {AutocompleteOption, AutocompleteVal} from '../SearchApartment';

interface UserTypeSelectProps extends Partial<AutocompleteRenderInputParams> {
  initVal?: string;
  onChange: (value: AutocompleteOption) => void;
}

export function UserTypeSelect({onChange, initVal, ...otherProps}: UserTypeSelectProps) {
  const [roleOptions, setRoleOptions] = useState<AutocompleteOption[]>([]);
  const [val, setVal] = useState<AutocompleteVal>(null);
  const [loading, setLoading] = useState(false);

  const handleSelect = (e: any, val: AutocompleteOption) => {
    setVal(val);
    onChange(val);
  };

  useEffect(() => {
    if (initVal && roleOptions.length > 0) {
      setVal(roleOptions.filter(s => s.value === initVal)[0] as AutocompleteOption);
    }
  }, [initVal, roleOptions]);

  useEffect(() => {
    setLoading(true);
    roleServiceFind()
      .then(res => {
        const rolesData = res.data?.roles || [];

        // Filter roles to include Org Admin, Org Operator, and Org Manager
        const allowedRoles = ['Org Admin', 'Org Operator', 'Org Manager'];
        const filteredRoles = rolesData.filter(role => allowedRoles.includes(role.name || ''));

        setRoleOptions(filteredRoles.map(_ => ({label: _.name, value: _.id})));
      })
      .catch(error => {
        console.error('Error fetching roles:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Autocomplete
      size="small"
      disabled={loading}
      fullWidth
      disableClearable
      options={roleOptions}
      onChange={handleSelect}
      // @ts-ignore
      value={val}
      renderInput={params => (
        <TextField
          {...params}
          label="User Type"
          variant="standard"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      {...otherProps}
    />
  );
}
